import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { SET_DEVICE_ALARMS_ENABLED_URL } from "./api-url.constants";
import { SetDeviceAlarmsEnabledApiDto } from "./dtos";
import { DeviceUpdateError } from "./errors";

export const setDeviceAlarmsEnabledByMonitorId = async (
  data: SetDeviceAlarmsEnabledApiDto
): Promise<void> => {
  const { monitorId, status } = data;

  const response = await typedFetch(
    `${SET_DEVICE_ALARMS_ENABLED_URL}/${monitorId}/alarms-enabled`,
    {
      method: API_METHODS.PATCH,
      body: JSON.stringify({ status }),
    }
  );

  if (!response.ok) throw new DeviceUpdateError();
};
